<template>
  <section class="main-section">
    <!-- Hero Section -->
    <section id="hero" class="hero-section">
      <div class="hero-content" data-aos="fade-up">
        <p class="hero-subtitle">SWISS TRADING SYSTEM</p>
        <h1 class="hero-title">Precisão Suíça.<br>Trading com confiança, <span class="hero-title-accent">feito para você!</span></h1>
        <p class="hero-description">Bem-vindo à Comunidade SWISS! Aqui você encontra uma família, um espaço acolhedor para aprender, investir e crescer junto com outros traders. Nosso objetivo é tornar o trading mais simples, objetivo e acessível.</p>
        <!-- Countdown Timer -->
        <div class="countdown-container">
          <!--<div class="countdown-label">PRESENTE DE NATAL SWISS</div>
          <div class="countdown-timer">
            <div class="countdown-item">
              <span class="countdown-value">{{ countdown.days }}</span>
              <span class="countdown-label-small">Dias</span>
            </div>
            <div class="countdown-item">
              <span class="countdown-value">{{ countdown.hours }}</span>
              <span class="countdown-label-small">Horas</span>
            </div>
            <div class="countdown-item">
              <span class="countdown-value">{{ countdown.minutes }}</span>
              <span class="countdown-label-small">Min</span>
            </div>
            <div class="countdown-item">
              <span class="countdown-value">{{ countdown.seconds }}</span>
              <span class="countdown-label-small">Seg</span>
            </div>
          </div>-->
          <button class="hero-cta" @click="scrollToSection('planos')">Ver Tecnologia</button>
        </div>
      </div>
    </section>

    <!-- O Ecossistema Section -->
    <section id="ferramentas" class="ecosystem-section">
      <div class="container">
        <p class="ecosystem-label">O ECOSSISTEMA</p>
        <h2 class="ecosystem-title">Soluções Exclusivas para Traders Premium</h2>
        <p class="ecosystem-description">Nosso Compromisso: Trading com confiança, feito para você. Resultados consistentes, sem perder a simplicidade.</p>
        <div class="ecosystem-cards">
          <div class="ecosystem-card" data-aos="fade-up" data-aos-delay="0">
            <div class="card-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <h3 class="card-title">Indicadores Exclusivos</h3>
            <p class="card-description">Tecnologia Inteligente, Mapeando as zonas de interesse e as regiões de posicionamento institucional.</p>
          </div>
          <div class="ecosystem-card" data-aos="fade-up" data-aos-delay="100">
            <div class="card-icon">
              <i class="fas fa-graduation-cap"></i>
            </div>
            <h3 class="card-title">Educação Personalizada</h3>
            <p class="card-description">Estudos e ensinamentos voltados para o seu desenvolvimento profissional como trader.</p>
          </div>
          <div class="ecosystem-card coming-soon card-robot" data-aos="fade-up" data-aos-delay="200">
            <div class="card-robot-header">
              <!--<span class="coming-soon-badge badge-left">EM BREVE</span>
              <a href="#" class="card-link">Saiba mais</a>-->
            </div>
            <h3 class="card-title">Estratégias Automatizadas</h3>
            <div class="card-video-wrapper">
              <video class="card-video" muted loop playsinline autoplay>
                <source src="/img/YAN-divulg.mp4" type="video/mp4">
              </video>
            </div>
            <p class="card-description">Algoritmos de alta performance</p>
          </div>
          <div class="ecosystem-card coming-soon" data-aos="fade-up" data-aos-delay="300">
            <span class="coming-soon-badge badge-right">EM BREVE</span>
            <div class="card-icon">
              <i class="fas fa-users"></i>
            </div>
            <h3 class="card-title">Copy Trade</h3>
            <p class="card-description">Diversifique seu capital seguindo operações validadas por profissionais direto da Europa.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Ferramentas Exclusivas Section -->
    <section class="tools-section">
      <div class="container">
        <p class="tools-label">TECNOLOGIA VISUAL</p>
        <h2 class="tools-title">Ferramentas Exclusivas</h2>
        <p class="tools-description">Tecnologia e engenharia de cálculos avançada e poderosa para apoiar e validar as suas decisões.<br>Menos ruído, mais assertividade no trading.</p>
        <div class="platforms-carousel-wrapper">
          <div class="platforms-marquee" aria-label="Plataformas parceiras">
            <div class="platforms-marquee-track">
              <div
                v-for="(platform, index) in platformsMarqueeSlides"
                :key="`platform-${index}`"
                class="platform-slide"
                :aria-hidden="index >= platformCarouselCount ? 'true' : undefined"
              >
                <div class="platform-card">
                  <p class="platform-card-name">{{ platform.name }}</p>
                  <img :src="platform.img" :alt="platform.name" class="platform-logo">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="charts-grid">
          <div class="chart-item" v-for="i in 6" :key="i" data-aos="fade-up" :data-aos-delay="(i-1) * 100">
            <img :src="`/img/indicator-${i}.png`" alt="Gráfico" class="chart-image" />
          </div>
        </div>
      </div>
    </section>

    <!-- Track Record Section -->
    <section id="resultados" class="track-record-section">
      <div class="container">
        <h2 class="section-title">TRACK RECORD</h2>
        <p class="section-subtitle">Números não mentem.</p>
        <p class="section-description">Nossa metodologia é validada todos os dias no mercado real.</p>
        <div class="track-record-content">
          <div class="track-item" data-aos="fade-right">
            <img src="/img/result-1.png" alt="Resultado 1" class="result-image" />
          </div>
          <div class="track-item" data-aos="fade-left">
            <img src="/img/result-2.png" alt="Resultado 2" class="result-image" />
          </div>
        </div>
          <!--<button class="btn-secondary">Ver Relatórios Completos</button>-->
      </div>
    </section>

    <!-- Indicou Ganhou Section -->
    <section class="indicou-ganhou-section">
      <div class="container">
        <div class="indicou-ganhou-banner" data-aos="fade-up">
          <i class="fas fa-gift indicou-ganhou-icon"></i>
          <h2 class="indicou-ganhou-title">INDICOU GANHOU</h2>
          <p class="indicou-ganhou-message">A cada 3 indicações, ganhe 1 mês de assinatura grátis.</p>
          <p class="indicou-ganhou-disclaimer">**Válido apenas para membros do Club SWISS</p>
        </div>
      </div>
    </section>

    <!-- Planos Section -->
    <section id="planos" class="plans-section">
      <div class="container">
        <h2 class="section-title">Escolha seu Plano</h2>
        <p class="section-subtitle">Temos assinaturas que melhor te atende.</p>

        <template v-if="activeProducts.length > 0">
          <!-- Abas Plataformas -->
          <div class="plans-platform-tabs">
            <button
              v-for="(prod, idx) in activeProducts"
              :key="prod.id"
              type="button"
              class="platform-tab"
              :class="{ active: selectedPlatformIndex === idx }"
              @click="selectedPlatformIndex = idx; selectedPeriodIndex = 0"
            >
              {{ platformLabel(prod.platform) || prod.name }}
            </button>
          </div>

          <div class="plans-content">
            <!-- Coluna esquerda: períodos -->
            <div class="plans-periods">
              <div
                v-for="(per, pIdx) in (selectedProduct && selectedProduct.periods) || []"
                :key="per.id"
                type="button"
                class="period-item"
                :class="{ active: selectedPeriodIndex === pIdx }"
                @click="selectedPeriodIndex = pIdx"
              >
                <div class="period-item-name">{{ per.periodName || per.period_name }}</div>
                <div class="period-item-prices">
                  <span v-if="(!showUsd || (showUsd && !(per.priceUsd != null && per.priceUsd > 0))) && per.price != null && per.price > 0">
                    <template v-if="per.promotion && (per.type === 'percent' || per.type === 'fixed')">
                      <span class="period-price-old">R$ {{ formatPrice(per.price) }}</span>
                      <span class="period-price-promo">R$ {{ formatPrice(promotionPrice(per)) }}</span>
                    </template>
                    <template v-else>
                      <span class="period-price">R$ {{ formatPrice(per.price) }}</span>
                    </template>
                  </span>
                  <span v-if="showUsd && per.priceUsd != null && per.priceUsd > 0" class="period-usd">
                    <template v-if="per.promotion && (per.type === 'percent' || per.type === 'fixed')">
                      <span class="period-price-old">US$ {{ formatPriceUsd(per.priceUsd) }}</span>
                      <span class="period-price-promo">US$ {{ formatPriceUsd(promotionPriceUsd(per)) }}</span>
                    </template>
                    <template v-else>
                      <span class="period-price">US$ {{ formatPriceUsd(per.priceUsd) }}</span>
                    </template>
                  </span>
                </div>
                <div v-if="per.promotion && per.expiration" class="period-item-validity">Válido até {{ per.expiration }}</div>
                <div v-if="getSecondSubscriptionDiscount(per) > 0" class="period-item-second-sub">
                  2ª assinatura: {{ getSecondSubscriptionDiscount(per) }}% de desconto
                  <span v-if="(!showUsd || !(per.priceUsd != null && per.priceUsd > 0)) && per.price != null && per.price > 0">
                    (R$ {{ formatPrice(secondSubscriptionPriceBrl(per)) }})
                  </span>
                  <span v-else-if="showUsd && per.priceUsd != null && per.priceUsd > 0">
                    (US$ {{ formatPriceUsd(secondSubscriptionPriceUsd(per)) }})
                  </span>
                </div>
              </div>
            </div>

            <!-- Coluna direita: descritivo + botão -->
            <div class="plans-detail">
              <div v-if="selectedProduct && selectedPeriod" class="plan-detail-card">
                <div class="plan-detail-header">
                  <h3 class="plan-detail-platform">{{ platformLabel(selectedProduct.platform) || selectedProduct.name }}</h3>
                  <img v-if="platformLogo(selectedProduct.platform)" :src="platformLogo(selectedProduct.platform)" :alt="platformLabel(selectedProduct.platform)" class="plan-detail-logo" />
                </div>
                <p v-if="selectedProduct.desc" class="plan-detail-desc">{{ selectedProduct.desc }}</p>
                <p class="plan-detail-period">{{ selectedPeriod.periodName || selectedPeriod.period_name }}</p>
                <p class="plan-detail-desc">{{ selectedPeriod.description }}</p>
                <div v-if="getSecondSubscriptionDiscount(selectedPeriod) > 0" class="second-sub-notice plan-detail-notice">
                  <strong>2ª assinatura com {{ getSecondSubscriptionDiscount(selectedPeriod) }}% de desconto</strong>
                  <span>Para quem já possui assinatura ativa. A validade será a mesma da assinatura principal.</span>
                </div>
                <div class="plan-detail-price">
                  <template v-if="(!showUsd || (showUsd && !(selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0))) && selectedPeriod.price != null && selectedPeriod.price > 0">
                    <span v-if="selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed')" class="price-original">R$ {{ formatPrice(selectedPeriod.price) }}</span>
                    <span class="price-amount">R$ {{ formatPrice(selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed') ? promotionPrice(selectedPeriod) : selectedPeriod.price) }}</span>
                  </template>
                  <template v-if="showUsd && selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0">
                    <span v-if="selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed')" class="price-original">US$ {{ formatPriceUsd(selectedPeriod.priceUsd) }}</span>
                    <span class="price-amount">US$ {{ formatPriceUsd(selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed') ? promotionPriceUsd(selectedPeriod) : selectedPeriod.priceUsd) }}</span>
                  </template>
                </div>
                <p v-if="getSecondSubscriptionDiscount(selectedPeriod) > 0" class="plan-detail-second-price">
                  <template v-if="(!showUsd || !(selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0)) && selectedPeriod.price != null && selectedPeriod.price > 0">
                    Na 2ª assinatura: <strong>R$ {{ formatPrice(secondSubscriptionPriceBrl(selectedPeriod)) }}</strong>
                  </template>
                  <template v-else-if="showUsd && selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0">
                    Na 2ª assinatura: <strong>US$ {{ formatPriceUsd(secondSubscriptionPriceUsd(selectedPeriod)) }}</strong>
                  </template>
                </p>
                <p v-if="selectedPeriod.promotion && selectedPeriod.expiration" class="plan-detail-validity">Válido até {{ selectedPeriod.expiration }}</p>
                <ul class="plan-detail-features">
                  <li>✓ Acesso conforme período</li>
                  <li>✓ Indicadores Swiss</li>
                  <li>✓ Suporte Premium</li>
                </ul>
                <button type="button" class="plan-button plan-detail-button" @click="openUserLogin">Assine agora e entre para o Club</button>
              </div>
              <div v-else class="plan-detail-empty">
                <p>Selecione um período ao lado.</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </section>

    <!-- Feedbacks Section -->
    <section id="feedbacks" class="feedbacks-section">
      <div class="container">
        <h2 class="section-title">FEEDBACK DA COMUNIDADE</h2>
        <p class="section-subtitle">Swiss é Vida.</p>
        <p class="section-description">Resultados reais de quem vive a nossa metodologia.</p>
        <div class="feedbacks-carousel-wrapper">
          <swiper :options="feedbacksSwiperOption" class="feedbacks-swiper">
            <swiper-slide v-for="i in 9" :key="i" class="feedback-slide">
              <div class="feedback-item">
                <img :src="`/img/depo-${i}.png`" alt="Depoimento" class="feedback-image" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="feedbacks-pagination"></div>
        </div>
      </div>
    </section>

    <!-- Área de Assinantes Section -->
    <section class="subscribers-section">
      <div class="container">
        <h2 class="section-title">ÁREA DE ASSINANTES</h2>
        <p class="section-subtitle">Uma Experiência Única</p>
        <button class="btn-primary" @click="openUserLogin">Entre para o Club Swiss</button>
        <div class="subscribers-features">
          <div class="feature-item" data-aos="fade-up">
            <h3 class="feature-title">Ferramentas de Precisão</h3>
            <p class="feature-description">Soluções Exclusivas para Traders Premium</p>
          </div>
          <div class="feature-item" data-aos="fade-up" data-aos-delay="100">
            <h3 class="feature-title">Conteúdo Exclusivo</h3>
            <ul class="feature-list">
              <li>Aulas ao vivo diariamente B3 + Mercado Internacional</li>
              <li>Salas de Estudos / Análises</li>
              <li>Ambiente Educacional com especialistas</li>
              <li>Suporte qualificado + Educadores Experientes</li>
            </ul>
          </div>
        </div>
        <div class="lives-section" data-aos="fade-up">
          <img src="/img/swiss-banner-lives.jpg" alt="Lives ao Vivo" class="lives-banner" />
        </div>
      </div>
    </section>

    <!-- CTA Final Section -->
    <section class="cta-section">
      <div class="container">
        <h2 class="cta-title">O Trading é para todos.<br>O sucesso é apenas para quem escolhe o caminho certo. Swiss Money: Seu caminho. Sua direção. Seu sucesso</h2>
      </div>
    </section>

    <!-- Contato Section -->
    <section class="contact-section">
      <div class="container">
        <h3 class="contact-title">Contato</h3>
        <div class="contact-telegram" @click="gotoTelegram">
          <img src="/img/telegram.png" alt="Telegram Suporte" class="telegram-icon" />
          <span>Telegram Suporte</span>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { getGrouped } from '../../admin/api/product'
import { getGeo } from '../api/geo'
import logger from '../../logger'

const PLATFORM_CAROUSEL_ITEMS = [
  { name: 'TradingView', img: '/img/logo-tv.png' },
  { name: 'NinjaTrader', img: '/img/logo-nt.png' },
  { name: 'Profit', img: '/img/logo-profit.png' },
  { name: 'BlackArrow', img: '/img/logo-ba.png' }
]

export default {
  name: 'main',
  props: ['businessUrl', 'new'],
  created () {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    })
  },
  data () {
    return {
      API_IMG: process.env.VUE_APP_IMG,
      products: [],
      selectedPlatformIndex: 0,
      selectedPeriodIndex: 0,
      userCountry: null,
      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      },
      countdownInterval: null,
      targetDate: new Date('2024-12-31T23:59:59'),
      platformCarouselCount: PLATFORM_CAROUSEL_ITEMS.length,
      feedbacksSwiperOption: {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.feedbacks-pagination',
          clickable: true
        },
        breakpoints: {
          480: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 24 },
          1024: { slidesPerView: 3, spaceBetween: 30 }
        }
      }
    }
  },
  computed: {
    ...mapState(['showLogin', 'reload', 'user']),
    activeProducts () {
      return (this.products || []).filter(p => p.active)
    },
    selectedProduct () {
      if (!this.activeProducts.length) return null
      const i = Math.min(this.selectedPlatformIndex, this.activeProducts.length - 1)
      return this.activeProducts[i]
    },
    selectedPeriod () {
      const prod = this.selectedProduct
      if (!prod || !prod.periods || !prod.periods.length) return null
      const i = Math.min(this.selectedPeriodIndex, prod.periods.length - 1)
      return prod.periods[i]
    },
    showUsd () {
      return this.userCountry && this.userCountry !== 'BR'
    },
    platformsMarqueeSlides () {
      return [...PLATFORM_CAROUSEL_ITEMS, ...PLATFORM_CAROUSEL_ITEMS]
    }
  },
  mounted () {
    this.getData()
    getGeo().then(r => { this.userCountry = r.country }).catch(() => {})
    document.body.style.backgroundColor = '#000'
    this.startCountdown()
  },
  beforeDestroy () {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
  methods: {
    async getData () {
      try {
        this.products = await getGrouped()
      } catch (error) {
        logger.error(error, this)
      }
    },
    formatPrice (price) {
      if (price == null) return '0,00'
      return Number(price).toLocaleString('pt-br', { minimumFractionDigits: 2 })
    },
    formatPriceUsd (price) {
      if (price == null) return '0.00'
      return Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    platformLabel (platform) {
      const labels = {
        profit: 'Profit',
        blackarrow: 'BlackArrow',
        ninjatrader: 'NinjaTrader',
        tradingview: 'TradingView',
        profit_yan: 'Profit Yan',
        blackarrow_yan: 'BlackArrow Yan',
        ninjatrader_yan: 'NinjaTrader Yan'
      }
      return labels[platform] || platform || ''
    },
    platformLogo (platform) {
      const logos = {
        profit: '/img/logo-profit.png',
        profit_yan: '/img/logo-profit.png',
        tradingview: '/img/logo-tv.png',
        ninjatrader: '/img/logo-nt.png',
        ninjatrader_yan: '/img/logo-nt.png',
        blackarrow: '/img/logo-ba.png',
        blackarrow_yan: '/img/logo-ba.png'
      }
      return logos[platform] || null
    },
    promotionPrice (per) {
      const price = Number(per.price) || 0
      const discount = Number(per.discount) || 0
      if (per.type === 'percent') return Math.max(0, price * (1 - discount / 100))
      if (per.type === 'fixed') return Math.max(0, price - discount)
      return price
    },
    promotionPriceUsd (per) {
      const priceUsd = Number(per.priceUsd) || 0
      const discount = Number(per.discount) || 0
      if (per.type === 'percent') return Math.max(0, priceUsd * (1 - discount / 100))
      if (per.type === 'fixed') return Math.max(0, priceUsd - discount)
      return priceUsd
    },
    getSecondSubscriptionDiscount (per) {
      if (!per) return 0
      const v = per.secondSubscriptionDiscount != null
        ? per.secondSubscriptionDiscount
        : per.second_subscription_discount
      return Math.min(100, Math.max(0, parseInt(v) || 0))
    },
    periodPriceBrl (per) {
      if (!per) return 0
      if (per.promotion && (per.type === 'percent' || per.type === 'fixed')) return this.promotionPrice(per)
      return Number(per.price) || 0
    },
    periodPriceUsd (per) {
      if (!per) return 0
      if (per.promotion && (per.type === 'percent' || per.type === 'fixed')) return this.promotionPriceUsd(per)
      return Number(per.priceUsd) || 0
    },
    secondSubscriptionPriceBrl (per) {
      const base = this.periodPriceBrl(per)
      const pct = this.getSecondSubscriptionDiscount(per)
      return Math.round(base * (100 - pct)) / 100
    },
    secondSubscriptionPriceUsd (per) {
      const base = this.periodPriceUsd(per)
      const pct = this.getSecondSubscriptionDiscount(per)
      return Math.round(base * (100 - pct)) / 100
    },
    startCountdown () {
      this.countdownInterval = setInterval(() => {
        const now = new Date().getTime()
        const distance = this.targetDate.getTime() - now

        if (distance > 0) {
          this.countdown.days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0')
          this.countdown.hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0')
          this.countdown.minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0')
          this.countdown.seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0')
        } else {
          this.countdown.days = '00'
          this.countdown.hours = '00'
          this.countdown.minutes = '00'
          this.countdown.seconds = '00'
        }
      }, 1000)
    },
    scrollToSection (sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    gotoTelegram () {
      window.open('https://t.me/SuporteSwissMoney', '_blank')
    },
    openUserLogin () {
      if (this.user) {
        this.$router.push('/usuario')
      } else {
        this.$store.commit('showLogin', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.main-section {
  padding-top: 70px;
  background: #000;
  color: #fff;
  min-height: 100vh;
}

@media screen and (min-width: 1024px) {
  .main-section {
    padding-top: 110px; /* Header height + market indicators */
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

// Hero Section
.hero-section {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  padding: 80px 20px;
  text-align: center;
}

.hero-content {
  max-width: 900px;
}

.hero-subtitle {
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #0088cc;
  margin: 0 0 20px 0;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 30px;
  line-height: 1.2;
  color: #fff;
}

.hero-title-accent {
  color: #0088cc;
}

.hero-description {
  font-size: 18px;
  line-height: 1.6;
  color: #e0e0e0;
  margin-bottom: 50px;
}

.countdown-container {
  margin-top: 40px;
}

.countdown-label {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: linear-gradient(to bottom right, #5134f5, #8d6ef4);
}

.countdown-timer {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #1a1a1a;
  padding: 20px 30px;
  border-radius: 10px;
  border: 2px solid linear-gradient(to bottom right, #5134f5, #8d6ef4);;
}

.countdown-value {
  font-size: 48px;
  font-weight: 700;
  color: linear-gradient(to bottom right, #5134f5, #8d6ef4);
  line-height: 1;
}

.countdown-label-small {
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}

.hero-cta {
  padding: 15px 40px;
  background: linear-gradient(to bottom right, #5134f5, #8d6ef4);
  color: #000;
  border: none;
  border-radius: 30px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 255, 136, 0.3);
  }
}

// Ecosystem Section
.ecosystem-section {
  padding: 100px 20px;
  background: #0a0a0a;
}

.ecosystem-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #0088cc;
  text-align: center;
  margin: 0 0 15px 0;
}

.ecosystem-title {
  font-size: 42px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  color: #fff;
}

.ecosystem-description {
  font-size: 18px;
  text-align: center;
  color: #999;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.ecosystem-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-top: 60px;
}

.ecosystem-card {
  background: #1a1a1a;
  padding: 40px 30px;
  border-radius: 15px;
  text-align: center;
  border: 2px solid transparent;
  transition: all 0.3s;
  position: relative;

  &:hover {
    border-color: #0088cc;
    transform: translateY(-5px);
  }

  &.coming-soon {
    opacity: 0.95;
  }

  &.card-robot {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}

.coming-soon-badge {
  position: absolute;
  top: 15px;
  background: #333;
  color: #fff;
  padding: 5px 15px;
  border-radius: 4px;
  border: 1px solid #555;
  font-size: 12px;
  font-weight: 600;

  &.badge-left {
    left: 15px;
    right: auto;
  }

  &.badge-right {
    right: 15px;
    left: auto;
  }
}

.card-robot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;

  .coming-soon-badge {
    position: relative;
    top: auto;
    left: auto;
  }
}

.card-link {
  color: #0088cc;
  font-size: 14px;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}

.card-video-wrapper {
  width: 100%;
  max-width: 280px;
  margin: 20px 0;
  border-radius: 10px;
  overflow: hidden;
  background: #0a0a0a;
}

.card-video {
  width: 100%;
  height: auto;
  display: block;
}

.card-icon {
  font-size: 48px;
  color: #0088cc;
  margin-bottom: 20px;
}

.card-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #fff;
}

.card-description {
  font-size: 16px;
  color: #999;
  line-height: 1.6;
}

@media screen and (max-width: 768px) {
  .ecosystem-cards {
    grid-template-columns: 1fr;
  }
}

.section-title {
  font-size: 42px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  color: #fff;
}

.section-subtitle {
  font-size: 24px;
  text-align: center;
  margin-bottom: 15px;
  color: #0088cc;
}

.section-description {
  font-size: 18px;
  text-align: center;
  color: #999;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

// Tools Section
.tools-section {
  padding: 100px 20px;
  background: #000;
}

.tools-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #0088cc;
  text-align: center;
  margin: 0 0 15px 0;
}

.tools-title {
  font-size: 42px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  color: #fff;
}

.tools-description {
  font-size: 18px;
  text-align: center;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.platforms-carousel-wrapper {
  margin-bottom: 60px;
  overflow: hidden;
}

.platforms-marquee {
  padding: 20px 0;
  overflow: hidden;
  mask-image: linear-gradient(to right, transparent, #000 8%, #000 92%, transparent);
}

.platforms-marquee-track {
  display: flex;
  align-items: stretch;
  gap: 12px;
  width: max-content;
  animation: platforms-marquee-scroll 28s linear infinite;
  will-change: transform;
}

@keyframes platforms-marquee-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.platform-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  flex-shrink: 0;
}

.platform-card {
  background: #1a1a1a;
  border-radius: 10px;
  padding: 16px 20px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.platform-card-name {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 12px 0;
  line-height: 1.2;
}

.platform-logo {
  max-width: 100px;
  max-height: 56px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.chart-item {
  background: #1a1a1a;
  border-radius: 10px;
  overflow: hidden;
}

.chart-image {
  width: 100%;
  height: auto;
  display: block;
}

// Track Record Section
.track-record-section {
  padding: 100px 20px;
  background: #0a0a0a;
  text-align: center;
}

.track-record-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
  margin: 60px 0;
}

.result-image {
  width: 100%;
  border-radius: 10px;
}

.btn-secondary {
  padding: 15px 40px;
  background: transparent;
  color: linear-gradient(to bottom right, #5134f5, #8d6ef4);
  border: 2px solid linear-gradient(to bottom right, #5134f5, #8d6ef4);
  border-radius: 30px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: linear-gradient(to bottom right, #5134f5, #8d6ef4);
    color: #000;
  }
}

// Indicou Ganhou Section
.indicou-ganhou-section {
  padding: 60px 20px;
  background: #000;
}

.indicou-ganhou-banner {
  max-width: 600px;
  margin: 0 auto;
  padding: 50px 40px;
  background: #0f0f0f;
  border: 2px solid #ffd700;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.15);
}

.indicou-ganhou-icon {
  font-size: 48px;
  color: #ffd700;
  margin-bottom: 25px;
}

.indicou-ganhou-title {
  font-size: 36px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #ffd700;
  margin: 0 0 20px 0;
}

.indicou-ganhou-message {
  font-size: 18px;
  color: #fff;
  line-height: 1.6;
  margin: 0 0 15px 0;
}

.indicou-ganhou-disclaimer {
  font-size: 14px;
  color: #ccc;
  margin: 0;
}

// Plans Section
.plans-section {
  padding: 100px 20px;
  background: #000;
}

.plans-platform-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 30px;
  margin-bottom: 24px;
}

.platform-tab {
  width: 180px;
  min-width: 180px;
  padding: 12px 16px;
  background: #1a1a1a;
  border: 2px solid #333;
  border-radius: 10px;
  color: #ccc;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s;
  text-align: center;

  &:hover {
    border-color: #5134f5;
    color: #fff;
  }

  &.active {
    border-color: #5134f5;
    background: linear-gradient(135deg, rgba(81, 52, 245, 0.2), rgba(141, 110, 244, 0.2));
    color: #fff;
  }
}

.plans-content {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 32px;
  margin-top: 20px;
  align-items: start;
}

.plans-periods {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.period-item {
  padding: 16px 20px;
  background: #1a1a1a;
  border: 2px solid #333;
  border-radius: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.25s;

  &:hover {
    border-color: #5134f5;
  }

  &.active {
    border-color: #5134f5;
    background: linear-gradient(135deg, rgba(81, 52, 245, 0.15), rgba(141, 110, 244, 0.15));
  }
}

.period-item-name {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.period-item-prices {
  font-size: 14px;
  color: #ccc;

  .period-price-old {
    text-decoration: line-through;
    margin-right: 8px;
    color: #888;
  }
  .period-price-promo {
    color: #8d6ef4;
    font-weight: 600;
  }
  .period-price {
    color: #fff;
  }
  .period-usd {
    margin-left: 12px;
  }
}

.period-item-validity {
  font-size: 12px;
  color: #8d6ef4;
  margin-top: 6px;
}

.period-item-second-sub {
  font-size: 12px;
  color: #c4b5fd;
  margin-top: 6px;
  line-height: 1.4;
}

.plans-detail {
  min-height: 280px;
}

.plan-detail-card {
  background: #1a1a1a;
  border: 2px solid #333;
  border-radius: 15px;
  padding: 32px 36px;
  text-align: left;
}

.plan-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 8px;
}

.plan-detail-platform {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.plan-detail-logo {
  width: 120px;
  height: auto;
  max-height: 40px;
  object-fit: contain;
  flex-shrink: 0;
}

.plan-detail-header + .plan-detail-period {
  margin-top: 0;
}

.plan-detail-period {
  font-size: 16px;
  color: #8d6ef4;
  margin: 0 0 16px 0;
}

.plan-detail-desc {
  font-size: 14px;
  color: #ccc;
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.plan-detail-price {
  margin-bottom: 12px;

  .price-original {
    text-decoration: line-through;
    font-size: 16px;
    color: #888;
    margin-right: 10px;
  }
  .price-amount {
    font-size: 28px;
    font-weight: 700;
    color: #8d6ef4;
  }
}

.plan-detail-validity {
  font-size: 14px;
  color: #ffc107;
  margin: 0 0 20px 0;
}

.second-sub-notice {
  margin: 12px 0;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(81, 52, 245, 0.15);
  border: 1px solid rgba(141, 110, 244, 0.45);
  font-size: 0.85em;
  line-height: 1.45;
  color: #e8e0ff;

  strong {
    display: block;
    margin-bottom: 4px;
    color: #fff;
  }

  span {
    display: block;
  }

  &.plan-detail-notice {
    margin-top: 0;
    margin-bottom: 14px;
  }
}

.plan-detail-second-price {
  font-size: 14px;
  color: #c4b5fd;
  margin: 0 0 12px 0;

  strong {
    color: #fff;
  }
}

.plan-detail-features {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;

  li {
    padding: 6px 0;
    color: #ccc;
    font-size: 14px;
  }
}

.plan-detail-button {
  width: 100%;
  padding: 16px;
  font-size: 16px;
}

.plan-detail-empty {
  background: #1a1a1a;
  border: 2px dashed #333;
  border-radius: 15px;
  padding: 48px;
  text-align: center;
  color: #666;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 60px;
}

.plan-card {
  background: #1a1a1a;
  border: 2px solid #333;
  border-radius: 15px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.3s;
  position: relative;

  &:hover {
    border-color: linear-gradient(to bottom right, #5134f5, #8d6ef4);
    transform: translateY(-5px);
  }
}

.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.plan-name {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
}

.promotion-badge {
  background: linear-gradient(135deg, #ff4444, #ff6666);
  color: #fff;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.plan-price {
  margin-bottom: 20px;
}

.plan-currency {
  font-size: 24px;
  color: linear-gradient(to bottom right, #5134f5, #8d6ef4);
}

.plan-amount {
  font-size: 48px;
  font-weight: 700;
  color: linear-gradient(to bottom right, #5134f5, #8d6ef4);
}

.plan-period {
  display: block;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}

.plan-description {
  font-size: 16px;
  color: #ccc;
  margin-bottom: 30px;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
  text-align: left;

  li {
    padding: 10px 0;
    color: #ccc;
    font-size: 14px;
  }
}

.plan-button {
  width: 100%;
  padding: 15px;
  background: linear-gradient(to bottom right, #5134f5, #8d6ef4);
  color: #000;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 255, 136, 0.3);
  }
}

// Feedbacks Section
.feedbacks-section {
  padding: 100px 20px;
  background: #0a0a0a;
}

.feedbacks-carousel-wrapper {
  margin-top: 60px;
  overflow: hidden;
  position: relative;
}

.feedbacks-swiper {
  padding: 20px 0 50px 0;
}

.feedback-slide {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.feedback-item {
  background: #1a1a1a;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.feedback-image {
  width: 100%;
  height: auto;
  display: block;
}

.feedbacks-pagination {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;

  ::v-deep .swiper-pagination-bullet {
    background: #555;
    opacity: 1;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background: #0088cc;
  }
}

// Subscribers Section
.subscribers-section {
  padding: 100px 20px;
  background: #000;
  text-align: center;
}

.btn-primary {
  padding: 20px 50px;
  background: linear-gradient(to bottom right, #5134f5, #8d6ef4);
  color: #000;
  border: none;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  margin: 40px 0 60px 0;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 255, 136, 0.3);
  }
}

.subscribers-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
  margin-bottom: 60px;
}

.feature-item {
  background: #1a1a1a;
  padding: 40px;
  border-radius: 15px;
  text-align: left;
}

.feature-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #00ff88;
}

.feature-description {
  font-size: 18px;
  color: #ccc;
  line-height: 1.6;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 10px 0;
    color: #ccc;
    font-size: 16px;
    line-height: 1.6;

    &::before {
      content: '✓ ';
      color: #00ff88;
      font-weight: 600;
      margin-right: 10px;
    }
  }
}

.lives-banner {
  width: 100%;
  max-width: 400px;
  border-radius: 15px;
  margin-top: 40px;
}

// CTA Section
.cta-section {
  padding: 100px 20px;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  text-align: center;
}

.cta-title {
  font-size: 36px;
  font-weight: 600;
  line-height: 1.4;
  color: #fff;
  max-width: 1000px;
  margin: 0 auto;
}

// Contact Section
.contact-section {
  padding: 60px 20px;
  background: #000;
  text-align: center;
}

.contact-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #fff;
}

.contact-telegram {
  display: inline-flex;
  align-items: center;
  gap: 15px;
  padding: 20px 40px;
  background: #1a1a1a;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #2a2a2a;
    transform: translateY(-2px);
  }

  span {
    font-size: 18px;
    font-weight: 600;
    color: #00ff88;
  }
}

.telegram-icon {
  height: 50px;
  width: auto;
}

// Responsive
@media screen and (max-width: 768px) {
  .hero-title {
    font-size: 32px;
  }

  .section-title {
    font-size: 32px;
  }

  .countdown-timer {
    gap: 10px;
  }

  .countdown-item {
    padding: 15px 20px;
  }

  .countdown-value {
    font-size: 32px;
  }

  .ecosystem-cards {
    grid-template-columns: 1fr;
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }

  .track-record-content {
    grid-template-columns: 1fr;
  }

  .plans-content {
    grid-template-columns: 1fr;
  }

  .plans-grid {
    grid-template-columns: 1fr;
  }

  .subscribers-features {
    grid-template-columns: 1fr;
  }

  .cta-title {
    font-size: 24px;
  }
}
</style>
